import { ConfirmationPopup } from '@components/Modal';
import { CommonUtility } from '@utility/common';
import styled from 'styled-components';

import { z } from 'zod';

const quantitySchema = z.object({
  allocated: z.number().default(0),
  damaged: z.number().default(0),
  transfer: z.number().default(0),
  shipment: z.number().default(0),
  available: z.number().default(0),
  total: z.number().default(0),
  uom: z.string().default(''),
});

const detailsSchema = z.object({
  locationId: z.string().default(''),
  locationCode: z.string().default(''),
  inventoryId: z.string().default(''),
  quantity: quantitySchema,
});

export const DeleteLocationSchema = z.object({
  details: detailsSchema,
  code: z.string().default(''),
  error: z.string().default(''),
  requestId: z.string().default(''),
});

export type TDeleteLocationSchema = z.infer<typeof DeleteLocationSchema>;

type TDeleteLocationPopupProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  title: string;
  message: string;
  errorObject: TDeleteLocationSchema | null;
};

const ErrorMessageContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.danger};
  padding: 10px;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.danger};
  background-color: ${({ theme }) => theme.colors.danger}0A;
`;

export function ConfirmDeleteLocationPopup({
  open,
  onClose,
  onConfirm,
  loading,
  title,
  message,
  errorObject,
}: TDeleteLocationPopupProps) {
  const messageRenderer = () => {
    if (CommonUtility.isValidObject(errorObject?.details)) {
      return (
        <ErrorMessageContainer>
          <span>Cannot delete location because it has inventory.</span>
          <div className="mt-2">
            {Object.keys(errorObject.details.quantity).map(key => {
              if (errorObject.details.quantity[key] > 0) {
                return (
                  <div key={key} className="d-flex">
                    <span>{CommonUtility.toTitleCase(key)}</span>
                    <span className="ml-2">{errorObject.details.quantity[key]}</span>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </ErrorMessageContainer>
      );
    }
    return message;
  };

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={messageRenderer()}
      loading={loading}
      closeText="Cancel"
      confirmText="Delete"
    />
  );
}
